import React, { useEffect, useRef } from 'react'
import { css } from '@emotion/react'

type Props = {
  children: React.ReactNode
  onKeyDown?: (e: React.KeyboardEvent) => void
  onKeyPress?: (e: React.KeyboardEvent) => void
}

export default function Keyboard(props: Props) {
  const ref = useRef<HTMLDivElement>(null)

  const keyboardClass = 'keyboard'

  useEffect(() => {
    if (
      ref.current &&
      document.activeElement &&
      !document.activeElement.closest(`.${keyboardClass}`)
    ) {
      ref.current.focus()
    }
  }, [ref.current])

  return (
    <div
      ref={ref}
      css={css`
        outline: none;
      `}
      className={keyboardClass}
      tabIndex={0}
      onKeyDown={props.onKeyDown}
      onKeyPress={props.onKeyPress}
    >
      {props.children}
    </div>
  )
}

export const handleKeyPress = (keyActionMap: {
  /**
   * @see https://www.w3.org/TR/uievents-key/#named-key-attribute-values
   */
  [keyName: string]: ((e: React.KeyboardEvent) => void) | undefined
}) => {
  return (e: React.KeyboardEvent) => {
    const handler = keyActionMap[e.key]
    if (handler) {
      handler(e)

      e.preventDefault()
      e.stopPropagation()
    }
  }
}
